<template>
  <b-card
    border-variant="light"
    bg-variant="light"
    body-class="px-4 py-4 text-center text-muted"
  >
    <b-icon-lock-fill class="mb-2" font-scale="1.5" />
    <p class="mb-1">
      {{ message || "You don't have permission to view this section." }}
    </p>
    <small>Contact your admin to request access.</small>
  </b-card>
</template>

<script>
export default {
  name: 'PermissionNotice',
  props: {
    message: { type: String, default: null },
  },
}
</script>
